// Main Tab Container
import { useState, useEffect } from "react";
import { useParams, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Tab, Nav, Button, Container, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import NavBar from "../../components/NavBar/NavBar";

const MeasurementDetailLayout = ({ auth, onLogout }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("details");
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!auth.token) {
            setError("Authentication token missing");
            return;
        }
        const tabFromUrl = location.pathname.split("/")[3] || "details";
        setActiveTab(tabFromUrl);
    }, [location, auth.token]);

    const tabs = [
        { id: "details", title: "Details"},
        { id: "raw", title: "Raw Data and Plot" },
        { id: "graph", title: "Processed Data Graphs"},
    ];

    if (error) {
        return (
            <Container fluid className="py-4">
                <NavBar auth={auth} onLogout={onLogout} />
                <Alert variant="danger" dismissible onClose={() => setError(null)}>
                    {error}
                </Alert>
            </Container>
        );
    }

    return (
        <>
            <NavBar auth={auth} onLogout={onLogout} />
            <Button
                variant="outline-secondary"
                onClick={() => navigate("/measurement")}
                className="m-4"
            >
                <FontAwesomeIcon icon={faArrowLeft}/> Back to Measurements
            </Button>

            <div className="d-flex flex-column align-items-center">
                <Tab.Container
                    activeKey={activeTab}
                    onSelect={(k) => navigate(`/measurement/${id}/${k}`)}
                >
                    <Nav variant="tabs">
                        {tabs.map((tab) => (
                            <Nav.Item key={tab.id}>
                                <Nav.Link
                                    eventKey={tab.id}
                                    className={`text-nowrap ${ activeTab === tab.id ? "fw-bold" : "" }`}
                                >
                                    {tab.title}
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>

                    {activeTab === "details" && (
                        <Tab.Content className="bg-light p-3 rounded mt-3" style={{ width: "800px"}}>
                            <Outlet context={{
                                measurementId: id,
                                auth,
                                onLogout
                            }} />
                        </Tab.Content>
                    )}

                    {(activeTab === "raw" || activeTab === "graph") && (
                        <Tab.Content className="bg-light p-3 rounded mt-3 w-100">
                            <Outlet context={{
                                measurementId: id,
                                auth,
                                onLogout
                            }} />
                        </Tab.Content>
                    )}
                </Tab.Container>
            </div>
        </>
    );
};

export default MeasurementDetailLayout;